import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CommonModule } from '@angular/common';
import {addPercent} from '../../../utils/numbers';


@Component({
  selector: 'app-brand-score-renderer',
  imports: [CommonModule],
  templateUrl: './brand-score-renderer.component.html',
  styleUrl: './brand-score-renderer.component.scss'
})
export class BrandScoreRendererComponent implements ICellRendererAngularComp{
  public score!: number | null;
  public narrow: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.loadComponent(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.loadComponent(params);
    return true;
  }

  private loadComponent(params: ICellRendererParams) {
    this.score = params.value ?? null;
    this.narrow = (params as any).narrow;
  }

  protected readonly addPercent = addPercent;
}
